"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends6 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _Link = _interopRequireDefault(require("../../typography/Link"));

var _InputControl = _interopRequireDefault(require("./InputControl"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'InputGroup');

function InputGroup(_ref) {
  var _classnames;

  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      id = _ref.id,
      name = _ref.name,
      type = _ref.type,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onEnter = _ref.onEnter,
      autoFocus = _ref.autoFocus,
      value = _ref.value,
      labelMode = _ref.labelMode,
      isFullWidth = _ref.isFullWidth,
      placeholder = _ref.placeholder,
      hint = _ref.hint,
      error = _ref.error,
      isRequired = _ref.isRequired,
      isReadOnly = _ref.isReadOnly,
      preComponent = _ref.preComponent,
      postComponent = _ref.postComponent,
      inputs = _ref.inputs,
      showInputsLabel = _ref.showInputsLabel,
      hideInputsLabel = _ref.hideInputsLabel,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "id", "name", "type", "onChange", "onBlur", "onFocus", "onEnter", "autoFocus", "value", "labelMode", "isFullWidth", "placeholder", "hint", "error", "isRequired", "isReadOnly", "preComponent", "postComponent", "inputs", "showInputsLabel", "hideInputsLabel"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // State && Callbacks

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showInputs = _useState2[0],
      setShowInputs = _useState2[1];

  var onLinkClick = (0, _react.useCallback)(function () {
    return setShowInputs(!showInputs);
  }, [showInputs]); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, InputGroup.overrides); // Classes

  var rootClassName = (0, _classnames3.default)(classes.root, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes.isFullWidth, isFullWidth), (0, _defineProperty2.default)(_classnames, classes[labelMode], labelMode), _classnames), classNameProp);
  var inputsControlClassName = (0, _classnames3.default)(classes.inputsControl, (0, _defineProperty2.default)({}, classes.hidden, !showInputs));
  var rootProps = {
    className: rootClassName
  };
  var onChangeInput = (0, _react.useCallback)(function (name, inputValue) {
    onChange && onChange((0, _extends6.default)({}, value, (0, _defineProperty2.default)({}, name, inputValue ? inputValue : '')));
  }, [onChange, value]);
  var onBlurInput = (0, _react.useCallback)(function (name, inputValue) {
    onBlur && onBlur((0, _extends6.default)({}, value, (0, _defineProperty2.default)({}, name, inputValue ? inputValue : '')));
  }, [onBlur, value]);
  var onEnterInput = (0, _react.useCallback)(function (name, inputValue) {
    onEnter && onEnter((0, _extends6.default)({}, value, (0, _defineProperty2.default)({}, name, inputValue ? inputValue : '')));
  }, [onEnter, value]);
  var onFocusInput = (0, _react.useCallback)(function (name, inputValue) {
    onFocus && onFocus((0, _extends6.default)({}, value, (0, _defineProperty2.default)({}, name, inputValue ? inputValue : '')));
  }, [onFocus, value]); // Principal inputs

  var inputProps = (0, _extends6.default)({
    id: id,
    type: type,
    labelMode: labelMode,
    isFullWidth: isFullWidth,
    placeholder: placeholder,
    hint: hint,
    error: error,
    isRequired: isRequired,
    isReadOnly: isReadOnly,
    name: inputs[0].name,
    label: inputs[0].label,
    value: value[inputs[0].name],
    autoFocus: autoFocus || inputs[0].autoFocus,
    onChange: onChangeInput,
    onFocus: onFocusInput,
    onBlur: onBlurInput,
    onEnter: onEnterInput,
    className: classes.Input
  }, override.Input); // Hidden inputs

  var inputsProps = (0, _extends6.default)({
    type: type,
    labelMode: labelMode,
    isFullWidth: isFullWidth,
    placeholder: placeholder,
    isReadOnly: isReadOnly,
    className: classes.Input
  }, override.Input);
  var hiddenInputs = inputs.slice(1);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends6.default)({}, rootProps, override.root), /*#__PURE__*/_react.default.createElement("div", (0, _extends6.default)({
    className: classes.formControl
  }, override.formControl), /*#__PURE__*/_react.default.createElement(_InputControl.default, (0, _extends6.default)({}, inputProps, {
    placeholder: inputsProps.placeholder || inputs[0].placeholder
  })), /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends6.default)({
    size: "small",
    onClick: onLinkClick
  }, override.Link), showInputs ? hideInputsLabel : showInputsLabel)), /*#__PURE__*/_react.default.createElement("div", (0, _extends6.default)({
    className: inputsControlClassName
  }, override.inputsControl), hiddenInputs.map(function (input) {
    return /*#__PURE__*/_react.default.createElement(_InputControl.default, (0, _extends6.default)({
      key: input.name,
      name: input.name,
      label: input.label,
      value: value[input.name],
      autoFocus: input.autoFocus,
      onChange: onChangeInput,
      onBlur: onBlurInput,
      overrides: {
        Label: {
          classes: {
            text: classes.hiddenInputLabel
          }
        }
      }
    }, inputsProps, {
      placeholder: input.placeholder || inputsProps.placeholder
    }));
  })));
}

InputGroup.overrides = ['root', 'Input', 'formControl', 'inputsControl', 'Link'];
InputGroup.defaultProps = {
  overrides: {},
  labelMode: 'horizontal',
  onChange: function onChange() {},
  value: {},
  inputs: [],
  isReadOnly: false,
  showInputsLabel: 'Show inputs',
  hideInputsLabel: 'Hide inputs'
};
process.env.NODE_ENV !== "production" ? InputGroup.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  onChange: _propTypes.default.func,
  inputs: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    name: _propTypes.default.string
  })).isRequired,

  /** Native input id */
  id: _propTypes.default.string,

  /** Native input name */
  name: _propTypes.default.string,

  /** Native input type */
  type: _propTypes.default.string,
  labelMode: _propTypes.default.oneOf(['horizontal', 'vertical']),

  /** Info popover */
  hint: _propTypes.default.string,

  /** Error will be displayed below the component with style changes */
  error: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  isReadOnly: _propTypes.default.bool,

  /** toggle button text for show/hide inputs */
  showInputsLabel: _propTypes.default.string,
  hideInputsLabel: _propTypes.default.string
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(InputGroup);

exports.default = _default;